<template>
  <div v-if="responses.length > 0" class="restricted-width">
    <v-list>
      <v-subheader>Responses</v-subheader>
      <div v-for="(response, i) in responses" :key="response.id">
        <v-sheet
          elevation="2"
          class="ma-2 pa-4 js-response"
          :id="`response-view-${i}`"
        >
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <th class="text-left">Question</th>
                  <td class="text-left js-response-question">
                    {{ response.key }}
                  </td>
                </tr>
                <tr>
                  <th class="text-left">Type</th>
                  <td class="text-left js-response-type">
                    {{ response.options.type }}
                  </td>
                </tr>
                <tr>
                  <th class="text-left">Choices</th>
                  <td
                    class="text-left js-response-choices"
                    v-if="response.options && response.options.choices"
                  >
                    {{ response.options.choices.join(", ") }}
                  </td>
                </tr>
                <tr>
                  <th class="text-left">Value</th>
                  <td class="text-left js-response-value" v-if="response.value">
                    {{
                      Array.isArray(response.value)
                        ? response.value.join(", ")
                        : response.value
                    }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-sheet>
      </div>
    </v-list>
  </div>
</template>
<script>
export default {
  props: { responses: Array }
}
</script>
